import { DRAWER_TOGGLE, DRAWER_COLLAPSE } from '../constants/ActionTypes'

const initialState = {
    isOpen: true,
    collapseOpen: {
        home: true,
        policyList: true,
        clientsTable: true
    }
}

/**
 * Reducer function for the drawer state.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the drawer.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The new state of the drawer.
 */
const ReducerDrawer = (state = initialState, action) => {
    switch (action.type) {

        case DRAWER_TOGGLE: {
            return {
                ...state,
                isOpen: !state.isOpen
            }
        }

        case DRAWER_COLLAPSE: {
            return {
                ...state,
                collapseOpen: {
                    ...state.collapseOpen,
                    [action.payload]: !state.collapseOpen[action.payload]
                }
            }
        }

        default: return state
    }
}

export default ReducerDrawer
